// Reusable tom-select multi/single select. data-controller="multi-select-v3"
// (+ multiple for tags). Dispatches "multi-select-v3:change" { value }.
// Must extend ApplicationController, never @hotwired/stimulus's Controller directly -- see docs/givsum3_08_july.md Section 9.
import ApplicationController from './application_controller'
import TomSelect from 'tom-select'
// Vendored/patched copy -- node_modules version fails to build. See docs Section 8.
import '../stylesheets/vendor/tom-select.bootstrap5.css'

export default class extends ApplicationController {
  static values = {
    placeholder: String,
  }

  connect() {
    console.log('🚀 multi-select-v3 connecting', this.element)
    try {
      this.select = new TomSelect(this.element, {
        // remove_button: per-item "x". clear_button: clear-all. Both in tom-select's complete build.
        plugins: this.element.multiple ? ['clear_button', 'remove_button'] : [],
        placeholder: this.placeholderValue || 'Select...',
        maxItems: this.element.multiple ? null : 1,
        onChange: (value) => this.dispatch('change', { detail: { value } }),
      })
      console.log('✅ multi-select-v3 initialized', this.select)
    } catch (error) {
      console.error('[multi-select-v3] failed to initialize', error)
    }
  }

  disconnect() {
    this.select?.destroy()
  }

  getValue() {
    return this.select?.getValue()
  }
}
